import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { auth } from "../../firebaseConfig";

export const readDataS10 = async () => {
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Unemployment Details"
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data(); // Return the form data
    } else {
      // console.log("No such document for Section 10!");
      return ;
    }
  } catch (error) {
    return;
    // console.error("Error fetching Section 9 data: ", error);
  }
};
